// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-hero-video_layout__25osY","video":"page-hero-video_video__vPILn","videoWrapper":"page-hero-video_videoWrapper__3P_Bp","overlay":"page-hero-video_overlay__pZZ1e"};